<script>
  import ClickOut from '../../../../utils/directives/clickout'

  export default {
    name: 'btn-acoes',
    props: ['leilao'],
    data () {
      return {
        open: false
      }
    },
    computed: {},
    mounted () {},
    destroyed () {
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      },
      renovarCache () {
        this.$emit('renovarCache')
      },
      emailsAutomaticos () {
        this.$emit('emailsAutomaticos')
      },
      updateTransmissaoUrl () {
        this.$emit('updateTransmissaoUrl')
      },
      gerarArquivoRemessa () {
        this.$emit('gerarArquivoRemessa')
      }
    },
    directives: {ClickOut},
    components: {}
  }
</script>

<template>
  <div class="btn-group dropdown" :class="{ open: open}" v-click-out="hide">
    <button class="btn btn-sm" data-toggle="dropdown" tabindex="1" aria-expanded="false" @click.stop.prevent="toggle">
      <i class="fa fa-terminal m-r-xs"></i> Ações <span class="m-l-sm caret"></span>
    </button>
    <ul class="dropdown-menu dropdown-menu-right no-padder">
      <li>
        <a tabindex="1" @click="renovarCache">
          <i class="fa fa-hdd-o m-r-xs"></i> Renovar Cache
        </a>
      </li>
      <li>
        <router-link :to="{name: 'leilao.monitor-comitente', params: {leilao: leilao.id}}" tabindex="2"><i
          class="fa fa-envelope-o fa-fw"></i> Enviar Cobrança de Vendidos
        </router-link>
      </li>
      <li>
        <a @click="emailsAutomaticos" tabindex="2"><i
          class="fa fa-envelope-o fa-fw"></i> Executar Envio Automático de E-mails
        </a>
      </li>
      <li>
        <a @click="updateTransmissaoUrl" tabindex="3"><i
          class="fa fa-video-camera fa-fw"></i> Atualizar Vídeo de Transmissão
        </a>
      </li>
      <li>
        <a @click="gerarArquivoRemessa" tabindex="3"><i
          class="fa fa-file-o fa-fw"></i> Gerar arquivo de remessa
        </a>
      </li>
    </ul>
  </div>
</template>



// WEBPACK FOOTER //
// BtnLeilaoAcoes.vue?3aae7b18